import { ProductModelService } from "../models";

export type NodePowerSource = {
  label: 'Battery' | 'Solar' | 'Grid';
  value: number;
};

export type NodePowerDestination = {
  label: 'Home' | 'Battery' | 'Grid';
  weight: number;
};

export type DeviceItem = {
  type: 'device' | 'system',
  label: string;
  id: string;
  isSelected: boolean;
};

export const getFlowDistribution = (
    home: number,
    batteryS: number,
    batteryD: number,
    solar: number,
    gridS: number,
    gridD: number,
  ): {
    fromSolarToHome?: number;
    fromSolarToBattery?: number;
    fromSolarToGrid?: number;
    fromGridToHome?: number;
    fromBatteryToHome?: number;
    fromBatteryToGrid?: number;
    fromGridToBattery?: number;
  } => {
  const _source: NodePowerSource[] = [
    {
      label: 'Grid',
      value: gridS,
    },
    {
      label: 'Battery',
      value: batteryS,
    },
    {
      label: 'Solar',
      value: solar,
    },
  ];
  const _destination: NodePowerDestination[] = [
    {
      label: 'Home',
      weight: home,
    },
    {
      label: 'Battery',
      weight: batteryD,
    },
    {
      label: 'Grid',
      weight: gridD,
    },
  ];

  let links = {};
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let indexD = 0; indexD < _destination.length; indexD++) {
    let weight = _destination[indexD].weight;
    const labelD = _destination[indexD].label;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let indexS = 0; indexS < _source.length; indexS++) {
      const { label: labelS, value } = _source[indexS];
      if (value === 0) {
        continue;
      }
      const temp = value - weight;
      if (temp === 0) {
        links = {
          ...links,
          [`from${labelS}To${labelD}`]: value,
        };
        _source[indexS].value = 0;
        break;
      } else if (temp > 0) {
        links = {
          ...links,
          [`from${labelS}To${labelD}`]: weight,
        };
        _source[indexS].value = temp;
        break;
      } else {
        links = {
          ...links,
          [`from${labelS}To${labelD}`]: value,
        };
        _source[indexS].value = 0;
        weight = -temp;
      }
    }
  }
  return links;
};

export const getTelemetryDeviceItem = (devices: Array<{ id: string }>, selectedDevice: DeviceItem | null) : DeviceItem[] => {
  let ids = devices.map((device) => device.id);
  const product = ids.map((id) => new ProductModelService(id));
  ids = product.filter(
    (p) => p.type?.name === 'connext' ||
    p.type?.name === 'inverter' ||
    p.type?.name === 'meter',
  ).map((p) => p.id);

  const items = ids.map((id) => ({
    type: 'device' as const,
    id,
    isSelected: selectedDevice?.id === id,
    label: id,
  }));
  return [...items, {
    type: 'system' as const,
    label: 'All',
    id: 'system',
    isSelected: !selectedDevice || selectedDevice.id === 'system',
  }].sort().reverse();
};
